import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch } from 'app/store';
import { fetchHolidaysFilterList } from 'api/holidaysFilterList';
import { MyKnownError, thunkErrorHandler } from 'features/thunkError';
import { IClientShortInfo } from '../clientInfo/clientInfoTypes';

export const getHolidaysFilterList = createAsyncThunk<
  { list: IClientShortInfo[]; count: number },
  void,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@holidaysFilterList/getHolidaysFilterList', async (_, thunkApi) => {
  try {
    const res = await fetchHolidaysFilterList();
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});
